import close from "assets/ic_close.png";
import React, { useEffect, useRef, useState } from "react";
import "./slideUp.scss";

const SlideUpNotice = ({
  isOpen = false,
  onBackDropClick,
  children,
  backDropStyle = {},
  closeButton = false,
  handleClose,
  closeOnBackDropClick = true,
  popupMargin = 0,
}) => {
  const [innerOpen, setInnerOpen] = useState(isOpen);
  const ref = useRef();

  useEffect(() => {
    let setTimeoutId = null;
    if (isOpen) {
      setInnerOpen(true);
    } else {
      setTimeoutId = setTimeout(() => {
        setInnerOpen(false);
      }, 500);
    }
    return () => {
      clearTimeout(setTimeoutId);
    };
  }, [isOpen]);

  useEffect(() => {
    // if (innerOpen) {
    //     disableBodyScroll(ref.current);
    // } else {
    //     const doc = document.querySelector('.slide-up-inner.show')
    //     if (!doc) {
    //         enableBodyScroll(ref.current);
    //     }
    // }
    // return () => {
    //     clearAllBodyScrollLocks()
    // }
  }, [innerOpen]);

  return (
    <div
      className={`slide-up slide-up-child common-full-width-extra border-1
        ${popupMargin && "pt-" + popupMargin + " px-" + popupMargin} 
        ${innerOpen ? "show" : ""}`}
      style={backDropStyle}
      onClick={() => {
        if (closeOnBackDropClick) {
          handleClose?.();
        }
        onBackDropClick?.();
      }}
    >
      <div
        ref={ref}
        className={`d-flex flex-column justify-content-end slide-up-inner ${
          isOpen ? "show" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {closeButton && (
          <img
            className="position-absolute hover"
            style={{ right: 20, top: 20 }}
            src={close}
            width={14}
            alt=""
            onClick={handleClose}
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default SlideUpNotice;
